module.exports = __webpack_public_path__ + "media/fonts/Oricons-6163e0bdbe14409b21868d7c4cd5f84c.woff";